import React, { useContext, useEffect } from 'react'
import { Button, Layout, Steps } from 'antd'
import MainLogo from 'assets/images/new-images/Finideas-New-Logo.png'
import BurgerMenu from 'assets/images/new-images/burger-menu.svg'
import MainRoutes from 'MainRoutes'
import { AppContext } from 'AppContext'
import HeaderNew from './HeaderNew'
import Menu from './Menu'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
import checkCircleForStep from 'assets/images/new-images/checkCircleForStep.svg'
import Footer from './footer'

const { Sider, Content } = Layout

const SiderNew = ({ currentUser, collapsed, setCollapsed, pathname }) => {
  const {
    state: { isAdmin, isClient, isMobile },
  } = useContext(AppContext)

  const { Step } = Steps

  const stepsForIndividual = [
    { title: 'Disclaimer' },
    { title: 'Select Type' },
    { title: 'Client Basic Details' },
    { title: 'Client Profile' },
    ...(currentUser?.cvlStatus === false ? [{ title: 'Kyc Documents' }] : []),
    { title: 'Risk Profile Assessment' },
    { title: 'Summary' },
    //{ title: 'Kyc E-Sign' },
    { title: 'Investment Planning' },
    { title: 'Agreement Sign' },
    { title: 'E-Mandate Registration' },
    { title: 'Congratulations' },
    { title: 'Pending Advisory' },
  ]

  const stepsForNonIndividual = [
    { title: 'Disclaimer' },
    { title: 'Select Type' },
    { title: 'Client Basic Details' },
    { title: 'Client Profile' },
    { title: 'Risk Profile Assessment' },
    { title: 'Summary' },
    { title: 'Investment Planning' },
    { title: 'Courier Instruction' },
  ]

  let tempCurrent = 0
  switch (currentUser?.completedSteps) {
    case 'LOGIN_CREATED':
      tempCurrent = 1
      break
    case 'SELECT_USER_TYPE':
      tempCurrent = 2
      break
    case 'CLIENT_PROFILE_1':
      tempCurrent = 3
      break
    case 'CLIENT_PROFILE_2':
      tempCurrent = 4
      break
    case 'KYC_DOC':
      tempCurrent = 5
      break
    case 'RISK_PROFILE':
      tempCurrent = 6
      break
    case 'SUMMARY':
      tempCurrent = 7
      break
    case 'INVESTMENT_PLANNING':
      tempCurrent = 8
      break
    case 'AGREEMENT_SIGN':
      tempCurrent = 9
      break
    case 'E_MANDATE':
      tempCurrent = 10
      break
    case 'CONGRATULATION':
      tempCurrent = 11
      break
    case 'DONE':
      tempCurrent = 14
      break
    default:
      break
  }

  const loadAiChatBot = () => {
    if (!isAdmin) {
      const script = document.createElement('script')
      script.src = 'https://chatling.ai/js/embed.js'
      script.async = true
      script.id = 'chatling-embed-script'
      script.setAttribute('data-id', '5276152696')

      const chatBotDiv = document.getElementById('chat-bot')
      if (chatBotDiv) {
        chatBotDiv.appendChild(script)
      }

      window.chtlConfig = { chatbotId: '5276152696' }

      return () => {
        if (chatBotDiv) {
          chatBotDiv.removeChild(script)
        }
      }
    }
  }

  useEffect(() => {
    loadAiChatBot()

    const checkChatBotLoaded = setInterval(() => {
      if (window.Chatling && typeof window.Chatling.open === 'function') {
        clearInterval(checkChatBotLoaded)
      }
    }, 500)

    return () => clearInterval(checkChatBotLoaded)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      const contentEl = document.querySelector('.content-wrapper');
      if (contentEl) {
        contentEl.setAttribute('tabindex', '-1');
        contentEl.focus();
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [pathname]);

  const handleSearchClick = () => {
    if (window.Chatling && typeof window.Chatling.open === 'function') {
      window.Chatling.open()
    } else {
      console.error('Chatbot library is not fully loaded yet.')
    }
  }

  return (
    <Layout className='layout'>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={274}
        role='complementary'
        aria-label='Main Sidebar Navigation'
        className={`sider ${collapsed ? 'sider-collapsed' : 'sider-expanded'
          } sider_new_scroll`}
      >
        <div className={`header ${collapsed ? 'header-collapsed' : ''}`}>
          {!collapsed && (
            <NavLink
              to='/'
              className='nav-text'
              style={{ display: `${isMobile && collapsed ? 'none' : 'block'}` }}
            >
              <img
                src={MainLogo}
                alt='Finideas Logo'
                className='logo'
                style={{ objectFit: 'cover' }}
              />
            </NavLink>
          )}
          <Button
            className='burger-menu-button'
            type='text'
            onClick={() => setCollapsed(!collapsed)}
          >
            <img
              style={{ width: collapsed ? '30px' : '100%' }}
              src={BurgerMenu}
              alt='Finideas Logo'
            />
          </Button>
        </div>
        <div className='menu-wrapper'>
          {currentUser?.completedSteps !== 'DONE' && isClient ? (
            <Steps direction='vertical' current={tempCurrent} status='process'>
              {(currentUser?.isPanCardIndividual
                ? stepsForIndividual
                : stepsForNonIndividual
              )?.map((step, index) => (
                <Step
                  key={index}
                  title={step.title}
                  icon={
                    index < tempCurrent ? (
                      <img src={checkCircleForStep} alt='checkCircleForStep' />
                    ) : null
                  }
                />
              ))}
            </Steps>
          ) : (
            <Menu pathname={pathname} setVisibleDrawer={setCollapsed} />
          )}
          {isClient && <div id='chat-bot'></div>}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              position: 'absolute',
              bottom: '0',
              width: '100%',
              backgroundColor: '#ffffff',
              paddingBottom: '10px',
              zIndex: 10,
            }}
          >
            <p style={{ color: '#8080806e' }}>23.10.02</p>
          </div>
        </div>
      </Sider>
      <Layout
        style={{
          marginLeft: collapsed
            ? isMobile
              ? 55
              : 90
            : currentUser?.completedSteps === 'DONE' || !isClient
              ? isMobile
                ? 0
                : 274
              : 0,
        }}
      >
        <HeaderNew />
        <Content className='content' tabIndex={0} role='main' aria-label='Main Content'>
          <div
            className={`content-wrapper ${isAdmin ? 'admin-content-wrapper' : ''
              }`}
            style={{ height: '100%' }}
          >
            <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>Finideas Page Content</h1>
            <MainRoutes />
          </div>
        </Content>
        {currentUser?.role !== 'ADMIN' && !isMobile && (
          <Footer
            currentUser={currentUser}
            handleSearchClick={handleSearchClick}
          />
        )}
      </Layout>
    </Layout>
  )
}

export default SiderNew
